import MobileBackButton from "./MobileBackButton";
import MobileMainItem from "./MobileMainItem";
import InfoBox from "./InfoBox";
import HTMLCheckboxListElement from "./HTMLCheckboxListElement";

export * from "./MobileBackButton";
export * from "./MobileMainItem";
export * from "./InfoBox";

export function registerElements() {
	window.customElements.define("mobile-back-button", MobileBackButton);
	window.customElements.define("mobile-main-item", MobileMainItem);
	window.customElements.define("info-box", InfoBox);
	window.customElements.define('checkbox-list', HTMLCheckboxListElement);
}